import type { Directive } from "vue";
import Dropdown from "bootstrap/js/dist/dropdown";

export const bsDropdownFixed: Directive<HTMLElement, any> = {
    mounted(el) {
        Dropdown.getOrCreateInstance(el, {
            popperConfig: {
                strategy: "fixed",
            },
        });
    },
    unmounted(el) {
        const instance = Dropdown.getInstance(el);
        instance?.dispose();
    },
};